import { RecordInitialStateType } from "../types/initialStateType";

export const recordIinitialState: RecordInitialStateType = {
  containerId: undefined,
  relatedEntityData: undefined,
  records: undefined,
};
